export const CATEGORIES = ['Furniture', 'Flooring',];